import SideNav from "./side-navigation";
import Tabs from "./tabs";
import Accordions from "./accordions";
import Sliders from "./sliders";
import Utility from "./utility";
import Stats from "./stats";
//import MoreProgramsSlider from "./more-programs-slider-plugin";
import AOISlider from "./aoi-slider";
import TestimonialsSliderPlugin from "./testimonials-slider";
import ImageSliderPlugin from "./image-slider";
import VideoSliderPlugin from "./video-slider";
import WysiwygSliderPlugin from "./wysiwyg-slider";
import Library from "./library";
import Cards from "./cards";
import FullWidth from "./full-width";
import Modal from "./modal";
import PausePlay from "./pause-play";
import StudentGroups from "./student-groups";
import ExpertBioCategories from "./expert-bio-categories";
import MultiSelect from "./multi-select";
import Video from "./video";
import VideoBanner from "./video-banner";
import VideoModal from "./video-modal";
import CustomGoogleMap from "./custom-google-map";
import QuickExit from "./quick-exit";
import Footer from "./footer";
import SlateOverrides from "./slateoverrides";
import UniversalFormTracking from "./universal-form-tracking";
import FeaturesSlider from "./slider-features";
import CTA from "./cta";
import VideoGallery from "./video-gallery";
//import BannerScroll from "./sc-banner-scroll";

class SaitApp {
    utilities: Utility = Utility;
    sidenav: SideNav;
    accordions: Accordions;
    tabs: Tabs;
    sliders: Sliders;
    stats: Stats;
    library: Library;
    cards: Cards;
    fullWidth: FullWidth;
    modal: Modal;
    pausePlay: PausePlay;
    studentGroups: StudentGroups;
    expertBioCategories: ExpertBioCategories;
    multiSelect: MultiSelect;
    video: Video;
    videoBanner: VideoBanner;
    videoModal: VideoModal;
    sideNav: SideNav;
    customGoogleMap: CustomGoogleMap;
    quickExit: QuickExit; 
    footer: Footer;
    slateOverride: SlateOverrides;
    universalFormTracking: UniversalFormTracking;
    featuresSlider: FeaturesSlider;
    cta: CTA;
    videoGallery: VideoGallery;
    //BannerScroll: BannerScroll;

    constructor() {
        this.init();
    }

    init() {
        this.tabs = new Tabs();
        this.tabs.start();
        let sliderPlugins = [
            //MoreProgramsSlider,
            TestimonialsSliderPlugin,
            ImageSliderPlugin,
            VideoSliderPlugin,
            WysiwygSliderPlugin,
            AOISlider
        ];
        this.accordions = new Accordions();
        this.accordions.start();
        this.sliders = new Sliders(sliderPlugins);
        this.stats = new Stats();
        this.stats.start();
        this.library = new Library();
        this.library.init();
        this.cards = new Cards();
        this.fullWidth = new FullWidth();
        this.modal = new Modal();
        this.pausePlay = new PausePlay();
        this.studentGroups = new StudentGroups();
        this.studentGroups.update();
        this.expertBioCategories = new ExpertBioCategories();
        this.multiSelect = new MultiSelect();
        this.video = new Video();
        this.videoBanner = new VideoBanner();
        this.videoModal = new VideoModal();
        this.sideNav = new SideNav();
        this.customGoogleMap = new CustomGoogleMap();
        this.quickExit = new QuickExit();
        this.footer = new Footer();
        this.slateOverride = new SlateOverrides();
        this.universalFormTracking = new UniversalFormTracking();
        this.featuresSlider = new FeaturesSlider();
        this.cta = new CTA();
        this.videoGallery = new VideoGallery();
        //this.BannerScroll = new BannerScroll();
    }
}
export default SaitApp;